// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"style_userInfo__fQzg6","driverShortID":"style_driverShortID__LBeG_","userProfile":"style_userProfile__y26YL","userInfoName":"style_userInfoName__j_HR1"};